var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0c.332 0 .64.167.808.442l5.063 8.214a.855.855 0 0 1 .005.895.949.949 0 0 1-.814.449H.937a.949.949 0 0 1-.814-.449.86.86 0 0 1 .005-.895L5.191.442A.946.946 0 0 1 6 0zm0 2.857a.548.548 0 0 0-.563.536v2.5c0 .297.25.536.563.536a.548.548 0 0 0 .562-.536v-2.5A.548.548 0 0 0 6 2.857zm.75 5c0-.394-.336-.714-.75-.714-.415 0-.75.32-.75.714 0 .395.335.714.75.714.414 0 .75-.32.75-.714z",
    fill: "#B2000C",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.6278deb0b66b6deeeda8d3b748ccded7.svg";
export { ForwardRef as ReactComponent };